export default __webpack_public_path__ + "static/media/furgonetka-sm-light.337b8f41.svg";